// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__g8l-X","content":"Layout_content__dsfGm","header":"Layout_header__yLPsQ"};